<template>

  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Author', to: '/author' },
      { label: 'Add New' }
    ]" title="New Author" />

    <div class="bg-white p-4">
      <form @submit.prevent="onSubmit">
        <div class="flex-col w-1/2 px-0 py-0">
        <label class="block font-medium mb-3 text-gray-700">Author Image (Optional)</label>
        <div
          class="relative w-36 h-36 border-2 border-dashed bg-gray-100 border-gray-300 rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-50"
          @click="triggerFileUpload">
          <input ref="fileInput" type="file" accept="image/*" class="hidden" @change="handleFileChange" />

          <div v-if="this.imageFile" class="absolute inset-0">
            <img :src="this.imageFile" alt="Author Image" class="object-cover w-full h-full rounded-lg" />
            <button class="absolute top-1 right-1 bg-white text-red-500 rounded-full py-0.5 px-1.5 hover:bg-gray-100"
              @click.stop="removeImage" title="Remove image">
              ✕
            </button>
          </div>

          <div v-else class="flex justify-center flex-col text-center align-middle items-center text-gray-400">
            <svg class="w-6 h-6 text-gray-500 text-center dark:text-white" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v6.41A7.5 7.5 0 1 0 10.5 22H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M9 16a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
                clip-rule="evenodd" />
            </svg>
            <p class="text-sm text-gray-500 m-0">Upload Image</p>
            <p class="text-xs text-gray-400 m-0">Max 2MB</p>
          </div>
        </div>
        <p v-if="errorMessageFile" class="text-red-500 text-sm mt-1">{{ errorMessageFile }}</p>
        <label class="block  mt-3 mb-3 font-medium text-gray-700">Author Name</label>
        <input 
        id="name" 
        type="text" 
        v-model="form.name" 
        placeholder="Enter Author Name" 
        :class="[
      'w-full rounded-md px-4 py-2.5 mb-3 text-sm focus:outline-none focus:ring-2',
      submitted && !form.name ? 'bg-red-300 focus:ring-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '
    ]" />
    <p v-if="submitted && !form.name" class="text-red-500 text-sm mt-0">Must be filled.</p>
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="block  mt-0 mb-3  font-medium text-gray-700">First Name (Optional)</label>
                <input
              id="name"
              type="text"
              v-model="form.first_name"
              placeholder="Enter First Name"
              :class="[
                'w-full rounded-md px-4 py-2.5 bg-gray-50 text-sm focus:outline-none focus:ring-2',
              ]"
            />
              </div>
              <!-- ... -->
              <div>
                <label class="block  mt-0 mb-3  font-medium text-gray-700">Last Name (Optional)</label>
                <input
              id="name"
              type="text"
              v-model="form.last_name"
              placeholder="Enter Last Name"
              :class="[
                'w-full rounded-md px-4 py-2.5 bg-gray-50 text-sm focus:outline-none focus:ring-2',
              ]"
            />
              </div>
              <div>
                <label class="block mt-0 mb-3 font-medium text-gray-700">Academic Title (Optional)</label>
                <input
              id="name"
              type="text"
              v-model="form.academic_title"
              placeholder="Enter Academic Title"
              :class="[
                'w-full rounded-md  px-4 py-2.5 bg-gray-50 text-sm focus:outline-none focus:ring-2',
              ]"
            />
              </div>
              <div>
                <label class="block mt-0 font-medium text-gray-700">Birth Date (Optional)</label>
                <DatetimeCustom :timeDate="false" class="mt-2 w-full mr-1.5" :label="''" v-model="form.birthdate"></DatetimeCustom>
              </div>
            </div>
            <label class="block  mt-3 mb-3 font-medium text-gray-700">Description (Optional)</label>
            <textarea
          v-model="form.meta"
          id="coupon-description"
          placeholder="Enter description about author..."
          rows="4"
          class="bg-gray-50 py-2.5 px-2 border h-36 rounded-lg w-full"
        ></textarea>
        <label class="text-gray-600 text-sm font-semibold mb-3 mt-3 block">Status</label>
            <div>
              <button clas type="button" @click="toggleActive" :class="{
                  'bg-blue-700': form.isActive,
                  'bg-gray-300': !form.isActive
                }" class="w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none">
                              <span :class="{
                  'translate-x-6': form.isActive,
                  'translate-x-0': !form.isActive
                }" class="w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200"></span>
              </button>
            </div>
      </div>
      <div class="flex items-center space-x-4 mt-3">
            <button type="submit"
              class="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-3 py-2 rounded-md">
              Save
            </button>
            <button type="button" @click="$router.push('/author')"
              class="border border-gray-300 text-gray-700 text-sm font-medium px-3 py-2 rounded-md hover:bg-gray-50">
              Cancel
            </button>
          </div>
      </form>
    </div>
  </div>

</template>

<script>
import { mapActions, mapState } from 'vuex';
import { AuthorPath } from '../../router/content';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import DatetimeCustom from '@/components/form/Datetime.vue'
import {EventBus} from '../../event-bus'
export default {
  components: {
    HeaderBreadcrumbs,
    DatetimeCustom
  },
  data() {
    return {
      imageFile: null,
      errorMessageFile: '',
      submitted: false,
      form: {
        name: null,
        file: null,
        isActive: true,
        birthdate: null,
        first_name: null,
        last_name: null,
        academic_title: null,
        meta: null,
      },
      AuthorPath,
    }
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.author.isLoading,
      isError: (state) => state.author.isError,
      errorMessage: (state) => state.author.errorMessage,
      successMessage: (state) => state.author.successMessage,
    }),
  },
  watch: {
    errorMessage: function (message) {
      if (!this.errorMessage) return;
    ///  this.messageAlert('error', message, 5000);
      EventBus.$emit('show-toast', {
            message: message,
            type: 'success',
          });
    },
    successMessage: function (message) {
      if (!this.successMessage) return;
      console.log(message)
     // this.messageAlert('success', message);
      EventBus.$emit('show-toast', {
            message:'New author has been added.',
            type: 'success',
          });
      this.$router.push(this.AuthorPath);
    },
  },
  methods: {
    ...mapActions('author', [
      'postAuthor',
    ]),
    onSubmit(event) {
      event.preventDefault();
      this.submitted = true;
      if (!this.form.name ) return; 
      const payload = this.form;
    
      this.postAuthor(payload);
    },
    onReset() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      if (!file.type.startsWith('image/')) {
        this.errorMessageFile = 'Only image files are allowed.';
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.errorMessageFile = 'Image size must be less than 2MB.';
        return;
      }

      this.errorMessageFile = '';
      this.imageFile = URL.createObjectURL(file)
      this.form.file = file
    },
    removeImage() {
      this.form.file = null;
      this.imageFile = null;
      this.$refs.fileInput.value = '';
    },
    toggleActive() {
      this.form.isActive = !this.form.isActive;
    },
    messageAlert(icon, title, timer = 3000) {
      this.$swal({
        toast: "true",
        position: "top-end",
        icon,
        title,
        showConfirmButton: false,
        timer,
        timerProgressBar: true,
      });
    },
  },
}
</script>
<style>
.button-active-inactive {
  position: relative;
  display: inline-flex;
  align-items: center;
}
</style>